import React, { useState } from "react";
import { loginUser } from '../features/user/userSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import {IMAGE_URL} from "../utils/constants";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const resultAction = await dispatch(loginUser({ email, password }));
    if (loginUser.fulfilled.match(resultAction)) {
      setLoading(false);
      const user = resultAction.payload;
      console.log("Logged in user:", user.user_details);
      if (user.user_details?.sub_admin_role === 'content_sub_admin') {
        navigate('/report-select-game');
      } else {
        navigate('/user');
      }
    } else if (loginUser.rejected.match(resultAction)) {
      console.error(resultAction.payload);
      setError(resultAction.payload);
      setLoading(false);
    }
  };

  return (
    <div className="credential_main_wrapper">
      <div className="credential_content_outer">
        <div className="credential_content_wrapper">
          <div className="credential_logo">
            <img src={`${IMAGE_URL}logo-white.svg`} alt="Logo" />
          </div>
        </div>
      </div>

      <div className="credential_form_wrapper">
        <div className="credential_form_card">
          <div className="credential_content_info">
            <h1>Log In</h1>
            <p className="mb-0 credential_sub_heading">
              Welcome back! Please enter your login details
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form_field_wrapper">
              <div className="form_field">
                <label htmlFor="email">Email Address</label>
                <div className="input_field">
                  <input
                    type="email"
                    className="form-control"
                    name="Email"
                    id="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <span className="error d-none">This is required field</span>
              </div>

              <div className="form_field">
                <label htmlFor="loginPassword">Password</label>
                <div className="input_field">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    name="password"
                    id="loginPassword"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={
                        showPassword
                          ? "fa-regular fa-eye"
                          : "fa-regular fa-eye-slash"
                      }
                      id="eyeLogin"
                    ></i>
                  </span>
                </div>
                <span className="error d-none">This is required field</span>
                 {error.detail &&
                <>
                <span className="error">
                    {error.detail}
                </span>
                </>}
              </div>
            </div>

            <div className="forgot_action_block d-flex justify-content-end align-items-center flex-wrap gap-2 mt-1">
              <div className="forgot-psw">
                <Link
                  to="/forget"
                  className="forgotpsw-link fw-semibold text-primary text-decoration-none"
                  type="button"
                >
                  Forgot password?
                </Link>
              </div>
            </div>

            <div className="form-btn-blk">
              {loading ? 
                 <button
                type="submit"
                className="form-btn w-100 fw-bold text-white text-capitalize"
                disabled
              >
                <img src={`${IMAGE_URL}btn_loader.gif`} alt="Logo" style={{height:"32px"}} />
              </button>

              : 
              <button
                type="submit"
                className="form-btn w-100 fw-bold text-white text-capitalize"
              >
                 Log In
              </button>
              }

            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
